import request from '@/utils/request'

export function signupMyPetrol(data) {
  return request({
    // url: '/auth/local/register',
    url: '/services/registerUser',
    method: 'post',
    data,
    timeout: 300000
  })
}

export function registerMyPetrol() {
  return request({
    url: '/mypetrol/user/register',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/signup.js